import React from "react";
import cx from "classnames";
import { useStaticQuery, graphql } from "gatsby";
import { Trans, useTranslation } from "react-i18next";

import Link from "../../Link";
import BenefitWithZMTs from "./animations/benefit-with-zmts";
import SignUpButton from "../../SignUpButton";

const BenefitWithZMT = (props) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      imagePipeline: file(relativePath: { eq: "images/pipeline.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <>
      <div id="benefit-with-zmt">
        <div className="container">
          <div className="pipeline">
            <img src={data.imagePipeline.publicURL} alt="Pipeline" />
          </div>
          <div className="text-center">
            <div
              data-sal="slide-up"
              data-sal-duration="400"
              data-sal-easing="ease-in-quad"
            >
              <span className="text-uppercase">
                {t("zmt.benefit.withZMT.subTitle")}
              </span>
            </div>
            <div
              data-sal="slide-up"
              data-sal-duration="500"
              data-sal-easing="ease-out-cubic"
              data-sal-delay="100"
            >
              <h2>
                <Trans
                  i18nKey="zmt.benefit.withZMT.title"
                  components={[<i>ZMTs</i>]}
                />
              </h2>
            </div>
          </div>

          <div className="row d-flex justify-content-center">
            <div
              className="col-12 col-lg-6"
              data-sal="slide-up"
              data-sal-duration="400"
              data-sal-easing="ease-in-quad"
            >
              <BenefitWithZMTs />
            </div>
          </div>

          <div
            className="row d-flex justify-content-center"
            data-sal="slide-up"
            data-sal-duration="400"
            data-sal-easing="ease-in-quad"
          >
            <div
              className={cx(
                "trading-fee-discount col-12 col-md-8 col-xl-4 mx-auto d-flex align-items-stretch"
              )}
            >
              <div className="card-dark-alt">
                <h4>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit1.title"
                    components={[<i>Trading</i>, <br className="desktop" />]}
                  />
                </h4>
                <p>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit1.description"
                    components={[<Link to="/fee-schedule/" />]}
                  />
                </p>
              </div>
            </div>
          </div>

          <div
            className="row"
            data-sal="slide-up"
            data-sal-duration="400"
            data-sal-easing="ease-in-quad"
          >
            <div className="col-xl-1 d-flex align-items-stretch"></div>
            <div className="col-12 col-md-8 col-xl-4 mx-auto mx-xl-0 d-flex align-items-stretch">
              <div className="card-dark-alt">
                <h4>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit2.title"
                    components={[<i>ZipUp</i>, <br className="desktop" />]}
                  />
                </h4>
                <p>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit2.description"
                    components={[<Link to={"/earn/"}>ZipUp</Link>]}
                  />
                </p>
                <SignUpButton
                  id="earn-now-btn"
                  className="button button-secondary button-buy mt-3"
                >
                  {t("zmt.benefit.withZMT.benefit2.btnEarnNow")} &#8594;
                </SignUpButton>
              </div>
            </div>
            <div className="col-12 col-md-8 col-xl-4 mx-auto mx-xl-0 d-flex align-items-stretch">
              <div className="card-dark-alt">
                <div className="coming-soon-badge">
                  <Trans i18nKey="zmt.benefit.comingSoon" components={[]} />
                </div>
                <h4>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit3.title"
                    components={[<i>Purchase</i>, <br className="desktop" />]}
                  />
                </h4>
                <p>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit3.description"
                    components={[]}
                  />
                </p>
              </div>
            </div>
          </div>

          <div
            className="row"
            data-sal="slide-up"
            data-sal-duration="400"
            data-sal-easing="ease-in-quad"
          >
            <div className="col-12 col-md-8 col-xl-4 mx-auto d-flex align-items-stretch">
              <div className="card-dark-alt">
                <div className="coming-soon-badge">
                  {t("zmt.benefit.comingSoon")}
                </div>
                <h4>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit4.title"
                    components={[
                      <i>Make Payments,</i>,
                      <br className="desktop" />,
                    ]}
                  />
                </h4>
                <p>
                  <Trans
                    i18nKey="zmt.benefit.withZMT.benefit4.description"
                    components={[<br className="desktop" />]}
                  />
                </p>
                {props.country === ".co.th" && (
                  <p
                    style={{
                      lineHeight: "1.5",
                      textAlign: "center",
                      color: "#fa4d68",
                    }}
                    className="mt-4"
                  >
                    <small>{t("zmt.benefit.note")}</small>
                  </p>
                )}
              </div>
            </div>
          </div>

          <div
            className="text-center other-privileges"
            data-sal="slide-up"
            data-sal-duration="400"
            data-sal-easing="ease-in-quad"
          >
            <span className="text-capitalize">
              {t("zmt.benefit.otherPrivileges.subTitle")}
            </span>
            <h2>{t("zmt.benefit.otherPrivileges.title")}</h2>
          </div>

          <div
            className="row other-privilege-benefits"
            data-sal="slide-up"
            data-sal-duration="400"
            data-sal-easing="ease-in-quad"
          >
            <div className="col-12 col-md-8 col-xl-4 mx-auto mx-xl-0 d-flex align-items-stretch">
              <div className="card-dark-alt">
                <h6>
                  <Trans
                    i18nKey="zmt.benefit.otherPrivileges.benefit1.title"
                    components={[<i>Purchase</i>]}
                  />
                </h6>
              </div>
            </div>
            <div className="col-12 col-md-8 col-xl-4 mx-auto mx-xl-0 d-flex align-items-stretch">
              <div className="card-dark-alt">
                <h6>
                  <Trans
                    i18nKey="zmt.benefit.otherPrivileges.benefit2.title"
                    components={[<i>Be a part of exclusive</i>]}
                  />
                </h6>
              </div>
            </div>
            <div className="col-12 col-md-8 col-xl-4 mx-auto mx-xl-0 d-flex align-items-stretch">
              <div className="card-dark-alt">
                <h6>
                  <Trans
                    i18nKey="zmt.benefit.otherPrivileges.benefit3.title"
                    components={[<i>Get</i>, <br className="desktop" />]}
                  />
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BenefitWithZMT;
